// extracted by mini-css-extract-plugin
module.exports = {"listItems":"ItemList_listItems__39BEx","todoGrid":"ItemList_todoGrid__1qZHq","shoppingGrid":"ItemList_shoppingGrid__3SuJe"};